import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { UigB2BUser } from '../../uig-user/uig-user.model';

@Injectable()
export class UigB2BUserAdapter {

  constructor (
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService
  ) {}

  // Deletes B2B User
  delete(userId: string): Observable<UigB2BUser> {
    return this.http.delete<UigB2BUser>(this.occEndpoints.buildUrl('uigUsersUserId', {urlParams: { userId }}));
  }
}
